/**
 * Hook for fetching current user's rewards
 */

import { useQuery } from '@tanstack/react-query'
import { rewardsApi } from '@api/endpoints/rewards'
import type { RewardInstanceStatus } from '@api/types/rewards'

export interface UseMyRewardsParams {
  status?: RewardInstanceStatus
  page?: number
  pageSize?: number
}

export function useMyRewards(params?: UseMyRewardsParams) {
  return useQuery({
    queryKey: ['my-rewards', params?.status, params?.page, params?.pageSize],
    queryFn: () => rewardsApi.getMyRewards(params),
  })
}
